import styled from 'styled-components';
import { colors, fonts, fontWeights, spacing, fontSizes, subtleShadow } from 'ui/theme';
import { BrandAffinityLevel } from 'modules/domains/brandAffinity';

export const BrandAffinityContainer = styled.div`
  font-family: ${fonts.sansSerif};
  font-weight: ${fontWeights.regular};
  padding: ${spacing.quarter} ${spacing.threeQuarter};
  border-radius: ${spacing.base};
  font-size: ${fontSizes.s12};
  white-space: nowrap;
  display: flex;
  align-items: center;
  background-color: ${colors.lavenderLighten40};
  color: ${colors.purple100};
  & svg {
    margin-right: ${spacing.half};
  }
  &[data-level='${BrandAffinityLevel.UNSCORED}'] {
    background-color: ${colors.lavenderLighten100};
  }
`;

export const BrandAffinityXAIIndicator = styled(BrandAffinityContainer)`
  font-family: inherit;
  font-weight: inherit;
  border-bottom-left-radius: ${spacing.base};
  border-top-left-radius: ${spacing.base};
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
`;

export const BrandAffinityXAIContainer = styled.div`
  display: flex;
  font-family: ${fonts.sansSerif};
  font-weight: ${fontWeights.regular};
  font-size: ${fontSizes.s12};
  border-radius: ${spacing.base};
  ${subtleShadow};
`;

export const BrandAffinityXAIPrompt = styled.div`
  cursor: pointer;
  padding: ${spacing.quarter} ${spacing.threeQuarter};
  border-bottom-right-radius: ${spacing.base};
  border-top-right-radius: ${spacing.base};
  display: flex;
  align-items: center;
`;

export const BrandAffinityXAIButton = styled.button`
  color: ${colors.purple100};
  background: none;
  border: none;
  padding: 0 ${spacing.quarter} 0 0;
  white-space: nowrap;
`;
